import {
    deleteFavorite,
    deleteFavoriteOverviewMarketsApi,
    manipulateFavoriteMarketGlobally,
    saveFavorite,
    saveFavoriteOverviewMarketsApi,
    toFavoriteMatch,
    toFavoritePreMatch,
    toFavoriteTournament,
    toggleFavorite
} from './FavoriteService';
import { GlobalFavMarketOperation, FavoriteType } from './Favorite';
import { dispatch } from 'nike-re-framejs';
import { List, Set } from 'immutable';
import { openMarketsChangeSucessDialog } from '../components/SportOverview';

export const toggleFavoriteMatch = (sportCode: string, match: any, isPrematch?: boolean) => db => {
    const favoriteMatch = isPrematch
        ? toFavoritePreMatch(sportCode, match.toJS())
        : toFavoriteMatch(sportCode, match.toJS());
    const favoriteMatches = db.getIn(['account', 'userFavourites', 'turboLive', 'matches'], []);
    const [toggledMatches, existing] = toggleFavorite(favoriteMatch, favoriteMatches);
    existing
        ? deleteFavorite(favoriteMatch.get('id'), FavoriteType.Match)
        : saveFavorite(favoriteMatch, FavoriteType.Match);
    return db.updateIn(['account', 'userFavourites', 'turboLive', 'matches'], [], () => toggledMatches);
};

export const toggleFavoriteTournament = (sportCode, tournament) => db => {
    const favoriteTournament = toFavoriteTournament(sportCode, tournament.toJS());
    const favoriteTournaments = db.getIn(['account', 'userFavourites', 'turboLive', 'tournaments'], []);
    const [toggledTournaments, existing] = toggleFavorite(favoriteTournament, favoriteTournaments);
    existing
        ? deleteFavorite(favoriteTournament.get('tournamentId'), FavoriteType.Tournament)
        : saveFavorite(favoriteTournament, FavoriteType.Tournament);

    return db.updateIn(['account', 'userFavourites', 'turboLive', 'tournaments'], [], () => toggledTournaments);
};

export const toggleFavoriteMarketGlobal = (marketId: string) => db => {
    const favoriteMarkets = db.getIn(['account', 'userFavourites', 'turboLive', 'marketsGlobal'], Set());
    const isMarketFavorite = favoriteMarkets.has(marketId);
    manipulateFavoriteMarketGlobally(
        marketId,
        isMarketFavorite ? GlobalFavMarketOperation.Delete : GlobalFavMarketOperation.Save
    );
    return db.updateIn(['account', 'userFavourites', 'turboLive', 'marketsGlobal'], Set(), () =>
        isMarketFavorite ? favoriteMarkets.delete(marketId) : favoriteMarkets.add(marketId)
    );
};

export const saveFavoriteOverviewMarkets = (sportCode, sportId, maxMediaCols) => db => {
    const selectedOverviewMarkets = db.getIn(['turboLive', 'selectedMarketIds', sportCode])?.take(maxMediaCols);
    if (selectedOverviewMarkets) {
        dispatch(clearMarketsSaveResponseStatus);
        saveFavoriteOverviewMarketsApi(sportId, selectedOverviewMarkets)
            .then(() => dispatch(saveResponseStatus(true)))
            .catch(() => dispatch(saveResponseStatus(false)));
        return db.updateIn(
            ['account', 'userFavourites', 'turboLive', 'overviewMarkets', String(sportId)],
            [],
            () => selectedOverviewMarkets
        );
    }

    return db;
};

const saveResponseStatus = status => db => {
    if (status) {
        openMarketsChangeSucessDialog();
    }
    return db.setIn(['account', 'userFavourites', 'turboLive', 'overviewMarketsSucess'], status);
};

export const clearMarketsSaveResponseStatus = db =>
    db.deleteIn(['account', 'userFavourites', 'turboLive', 'overviewMarketsSucess']);

export const deleteFavoriteOverviewMarkets = (sportCode, sportId) => db => {
    dispatch(clearMarketsSaveResponseStatus);
    deleteFavoriteOverviewMarketsApi(sportId)
        .then(() => dispatch(saveResponseStatus(true)))
        .catch(() => dispatch(saveResponseStatus(false)));
    return db
        .setIn(['account', 'userFavourites', 'turboLive', 'overviewMarkets', sportId], List())
        .deleteIn(['turboLive', 'selectedMarketIds', sportCode]);
};
